import process from './process.vue';
import test from './test/index.vue';

export default [
  {
    path: '',
    component: process,
    children: [
      {
        path: ':token',
        component: test,
        name: 'interview-test',
        props: true,
        meta: {
          title: 'interview_test.title',
          isOuter: true
        }
      }
    ]
  }
];
